/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function CellClassActionsRepresentationFromJSON(json) {
    return CellClassActionsRepresentationFromJSONTyped(json, false);
}
export function CellClassActionsRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        canRead: json['canRead'],
        canEdit: json['canEdit'],
    };
}
export function CellClassActionsRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        canRead: value.canRead,
        canEdit: value.canEdit,
    };
}
